import { Dispatch, SetStateAction } from 'react';

export interface AppConfigFormat {
  navDrawerPinned: boolean;
}

export type UseAppRemoteStateResult = [
  AppConfigFormat,
  Dispatch<SetStateAction<AppConfigFormat>>,
  { loading: boolean },
];

export enum UseAppRemoteStateUpdateReason {
  INITIAL,
  USER,
  REMOTE,
}

export interface UseAppRemoteStateState {
  data: AppConfigFormat;
  updateReason: UseAppRemoteStateUpdateReason;
  loading: boolean;
}
